import sanitizeHtml, { type IOptions } from "sanitize-html";

type SanitizeHtmlOptions = {
	allowedTags: string[];
	allowedAttributes?: string[];
	allowedSchemesByTag?: IOptions["allowedSchemesByTag"];
};

const DEFAULT_ALLOWED_SCHEMES = ["http", "https", "mailto", "tel"];

export function sanitizeAllowedHtml(html: string, options: SanitizeHtmlOptions): string {
	return sanitizeHtml(html, {
		allowedTags: options.allowedTags,
		allowedAttributes: {
			"*": options.allowedAttributes ?? [],
		},
		allowedSchemes: DEFAULT_ALLOWED_SCHEMES,
		allowedSchemesByTag: options.allowedSchemesByTag,
		allowProtocolRelative: false,
		disallowedTagsMode: "discard",
		transformTags: {
			a: (_tagName, attribs) => ({
				tagName: "a",
				attribs: {
					...attribs,
					...(attribs.target === "_blank" ? { rel: "noopener noreferrer" } : {}),
				},
			}),
		},
	});
}
